import moment from 'moment';
import commonFn from '@/commons/commonFunction';
import webSocket from '@/sockets/socket';
import store from '../store';

export default {
  resetState(state) {
    let x = 1;
    //Object.assign(state, defaultConfigState);
  },
  updateConfig: function (state, payload) {
    let currentDate = moment(payload.CurrentDate).toDate();
    state.ConfigInfo = {
      ...state.ConfigInfo,
      ...payload,
      CurrentDate: currentDate,
      CurrentDateText: moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
    };
  },
  updateCulture: function (state, payload) {
    state.Context.Culture = payload;
  },
  updateToken(state, payload) {
    state.TokenExpired = new Date().addSeconds(payload.tokenTimeout);
    state.Token = payload.token;
    state.User = payload.user;
    // state.Context = payload.Context;
    state.Permission = payload.Permission || null;
    state.PostedDate = new Date();
    // //ghi context vào localstorage
    // commonFn.setLocalStorage("TokenExpired", state.TokenExpired);
    // commonFn.setLocalStorage("Token", state.Token);
    // commonFn.setLocalStorage("User", JSON.stringify(state.User));
    // commonFn.setLocalStorage("Context", JSON.stringify(state.Context));
  },
  // restoreContext(state) {
  //   state.Token = commonFn.getLocalStorage("Token");
  //   state.User = JSON.parse(commonFn.getLocalStorage("User"));
  //   state.Context = JSON.parse(commonFn.getLocalStorage("Context"));
  // },
  updateLogout: function (state, payload) {
    state.Token = null;
    state.Context = null;
    state.TokenExpired = null;
    state.User = null;
    state.Permission = null;

    //xóa all storage
    sessionStorage.clear();
    localStorage.clear();
  },

  updateLoading(state, payload) {
    state.Loading = payload;
  },
  updatePermission(state, payload) {
    state.Permission = payload;
  },
  /**
   * clear thông tin phiên đăng nhập
   */
  removeToken(state) {
    state.Token = null;
    state.Context = { Culture: null };
    state.TokenExpired = null;
    state.User = null;
    state.Permission = null;

    //disconnect khi logout
  },

  updateLeftMenuCollapse(state, payload) {
    state.LeftMenuCollapse = payload;
  },
  completeGetting(state) {
    let getting = {
      GettingStarted: true,
      SeenGetting: true,
    };
    state.GettingStarted = getting;
    commonFn.setLocalStorage('GettingStarted', JSON.stringify(getting));
    window._getting = getting;
  },
  /**
   * Cập nhật postedDate
   * @param {*} state
   * @param {*} payload
   * tbngoc 28/07/2022
   */
  updatePostedDate(state, payload) {
    if (payload && payload.PostedDate) {
      state.PostedDate = payload.PostedDate;
    }
  },

  /**
   * kiểm tra xem có load form không
   * @param {*} state
   * @param {*} data
   */
  updateLoadFormMaster(state, data) {
    state.loadFormMaster = data;
  },

  updateCachePaging(state, data) {
    state.CachePaging = data;
  },

  clearCachePaging(state) {
    state.CachePaging = {
      IndexPage: 1,
      FilterObject: '',
      SearchKey: '',
      SelectValue: '',
    };
  },
  updateDeviceID(state, payload) {
    state.DeviceID = payload;
  },

  updateTicketCount(state, payload) {
    if (payload) {
      state.TicketCount = payload.TicketCount;
    }
  },

  updateRequestCount(state, payload) {
    if (payload) {
      state.RequestCount = payload.RequestCount;
    }
  },

  ReloadNotification(state,payload) {
    state.ReloadNotification = new Date().getTime();
  },
  
};
